<!-- Anzeige ZIP-Download inkl. Content -->
<template>
  <div class="zip__download">
    <h2>Download Label-Informationen</h2>

    <p>
      Aktualisierung der Daten erfolgt regelmäßig.
    </p>
    <p>
      Das Herunterladen der Codelisten ist als Service der GVL zur hausinternen
      Recherche von Label- und Herstellernamen vorgesehen.
      Die Weiterverarbeitung der Labeldaten gestattet die GVL nur für den
      internen Gebrauch der jeweiligen Anstalt. Die Weitergabe an Dritte, der
      zweckfremde Gebrauch oder eine kommerzielle Nutzung sind ausdrücklich
      untersagt.
    </p>

    <table v-if="zipFile !== null" class="zip__download__table" aria-describedby="Informationen über den ZIP-File und die enthaltenen Dateien">
      <thead>
        <tr>
          <th scope="col">Dateiname</th>
          <th scope="col">Zuletzt aktualisiert am</th>
          <th scope="col">Größe (MB)</th>
        </tr>
      </thead>
      <tbody>
        <tr @click="downloadZip()" class="zip__download--file">
          <td><strong>{{ zipFile.filename }}</strong></td>
          <td><strong>{{ zipFile.getLastModifiedFormatted() }}</strong></td>
          <td><strong>{{ zipFile.getSizeInMb() }}</strong></td>
        </tr>
        <tr>
          <td colspan="3" class="zip__download--subheader">
            <h3>Das Zip-Archiv behinhaltet folgende Dateien:</h3>
          </td>
        </tr>
        <tr class="zip__download--files" v-for="content in zipFile.contents" v-bind:key="content.filename">
          <td>{{ content.filename }}</td>
          <td>{{ content.getLastModifiedFormatted() }}</td>
          <td>{{ content.getSizeInMb() }}</td>
        </tr>
      </tbody>
    </table>

    <p class="error" v-if="zipFile === null">
      Leider aktuell kein Zip zum Download bereit.
    </p>
  </div>
</template>

<script>
import axios from 'axios'
import ZipFileModel from './Model.class.ts'

const URL_METADATA = '/api/v1/xml/metadata'

export default {
  name: 'ZipDownload',
  components: {},
  props: {},
  data () {
    return {
      zipFile: null
    }
  },
  mounted () {
    this.loadZipMetadata()
  },
  computed: {},
  methods: {
    downloadZip () {
      window.location.href = '/api/v1/xml'
    },
    getHttpClient () {
      delete axios.defaults.headers.common.Authorization
      return axios
    },
    loadZipMetadata () {
      this.getHttpClient()
        .get(URL_METADATA)
        .then((response) => {
          this.$log.debug('response: ', response)
          try {
            this.zipFile = new ZipFileModel(response.data)
          } catch (error) {
            this.logErrorloadZipMetadata(error.message)
          }
        }, (error) => {
          this.logErrorloadZipMetadata(error.message)
        })
    },
    logErrorloadZipMetadata (error) {
      this.$log.error(
        'Error while downloading zip information using url: {URL_METADATA}! Error is: '
          .replace(/\{URL_METADATA\}/, URL_METADATA),
        error)
    }
  }
}
</script>

<style lang="scss">
  .zip__download {
    margin: 90px auto 160px auto;
    overflow: hidden;
    padding: 1%;
    text-align: left;
    width: 90%;

    .zip__download__table {
      width: 100%;
    }

    .zip__download--file {
      cursor: pointer;
      color: #aa3c14;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    .zip__download--subheader {
      font-size: 0.8em;
    }

    .error {
      color: rgba(217, 20, 4, 1)
    }
  }
</style>
